import React from 'react'
import { Prompt } from 'react-router-dom'
import PropTypes from 'prop-types'

import { usePreventRefresh } from '../../hooks'

const DirtyPrompt = ({ isDirty }) => {
  usePreventRefresh(isDirty)

  return (
    <Prompt
      when={isDirty}
      message={`Please save your changes before leaving! \nIf you press ok your changes will be lost`}
    />
  )
}

DirtyPrompt.propTypes = {
  isDirty: PropTypes.bool,
}

DirtyPrompt.defaultProps = {
  isDirty: false,
}

export default DirtyPrompt
